import { useDispatch, useSelector } from 'react-redux';
import { Events } from 'redux/Events';
import Notifications from 'redux/Notifications';

const useEvents = () => {
  const dispatch = useDispatch();

  const createEvent = (event) => {
    dispatch(Events.startFetch());
    return dispatch(Events.createEvent(event))
      .then(() => {
        dispatch(Notifications.setSuccess('Event Created Successfully!', 'Success'));
      })
      .catch((err) => {
        dispatch(Notifications.setError(err));
      });
  };

  const setPlan = (plan) => {
    return dispatch(Events.modifyPlan(plan));
  };

  const setDisplay = (display) => {
    return dispatch(Events.modifyDisplay(display));
  };

  const clearDisplay = () => {
    return dispatch(Events.clearDisplay());
  };

  const setFilter = (filters) => {
    dispatch(Events.setFilter(filters));
  };
  const clearPlan = () => {
    dispatch(Events.clearPlan());
  };

  const clearFilter = () => {
    dispatch(Events.clearFilter());
  };
  const setPanel = (panel) => {
    dispatch(Events.setPanel(panel));
  };
  const setShowArchive = (showArchive) => {
    dispatch(Events.setShowArchive(showArchive));
  };
  const updateEvent = (event) => {
    dispatch(Events.startFetch());
    return dispatch(Events.editEvent(event)).catch((err) => {
      dispatch(Notifications.setError(err));
    });
  };

  const eventBatchUpdate = (events) => {
    dispatch(Events.eventBatchUpdate(events)).catch((err) => {
      dispatch(Notifications.setError(err));
    });
  };

  const deleteEvent = (event_id) => {
    dispatch(Events.startFetch());
    dispatch(Events.deleteEvent(event_id)).catch((err) => {
      dispatch(Notifications.setError(err));
    });
  };

  const fetchEvents = (params) => {
    dispatch(Events.startFetch());
    dispatch(Events.fetchEvents(params)).catch((err) => {
      dispatch(Notifications.setError(err));
    });
  };

  const fetchEventsCount = (params) => {
    dispatch(Events.startFetch());
    dispatch(Events.fetchEventsCount(params)).catch((err) => {
      dispatch(Notifications.setError(err));
    });
  };

  const setShowEventDetails = (view) => {
    return dispatch(Events.setShowEventDetails(view));
  };

  const events = useSelector(Events.getEvents);
  const eventsCount = useSelector(Events.getEventsCount);
  const isFetchingEvents = useSelector(Events.getIsFetchingEvents);
  const farmerPlan = useSelector(Events.getFarmerPlan);
  const currentPanel = useSelector(Events.getCurrentPanel);
  const valid = useSelector(Events.getPlanIsValid);
  const display = useSelector(Events.getPlanSpecialDisplay);
  const inputValidities = useSelector(Events.getPlanIsValid);
  const showEventDetails = useSelector(Events.getShowEventDetails);
  const filters = useSelector(Events.getFilters);
  const showArchive = useSelector(Events.getShowArchive);

  return {
    createEvent,
    updateEvent,
    eventBatchUpdate,
    deleteEvent,
    fetchEvents,
    fetchEventsCount,
    setShowEventDetails,
    setShowArchive,
    setPlan,
    clearPlan,
    setPanel,
    setFilter,
    clearFilter,
    filters,
    events,
    eventsCount,
    isFetchingEvents,
    farmerPlan,
    currentPanel,
    valid,
    display,
    inputValidities,
    showEventDetails,
    showArchive,
    setDisplay,
    clearDisplay,
  };
};

export default useEvents;
